import useDevice from '@/hooks/useDevice';
import { useEffect, useState } from 'react';
import MidtermDiscount from './midtermDiscount/MidtermDiscount';
import Drawer from '@/components/UI/drawer/Drawer';
import Modal from '@/components/UI/modal/Modal';
import { useRouter } from 'next/router';
const MidtermDiscountPopup = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const {
    isMobile
  } = useDevice();
  useEffect(() => {
    const hasSeenDialog = sessionStorage.getItem('mid-term-discount') === 'true';
    if (router.query.mid_term && !hasSeenDialog) {
      setOpen(true);
      sessionStorage.setItem('mid-term-discount', 'true');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  if (isMobile) {
    return <Drawer open={open} onClose={handleClose}>
        <MidtermDiscount handleClose={handleClose} />
      </Drawer>;
  } else {
    return <Modal open={open} onClose={handleClose}>
        <MidtermDiscount handleClose={handleClose} />
      </Modal>;
  }
};
export default MidtermDiscountPopup;